import { Typography } from '@mui/material'
import React from 'react'
import { PropsTextFunction } from '../../../styles'

export const SmallText = (props) => {
  return (
    <Typography
    variant="body2"
    component={props.link ? 'a' : 'p'}
    align={props?.align}
    sx={ { display: 'flex', alignItems: 'center', ...PropsTextFunction(props) } }
    className={`${props?.className}`}
    key={props.key}
    href={props.link}
    target="_blank"
    >
      { !props.iconEnd && props?.icon }
        { props?.text }
      { props.iconEnd && props?.icon }
    </Typography>
      )
    }
